import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {NameValueDTO} from '../../../models/NameValueDTO';

@Component({
  selector: 'app-element-select',
  templateUrl: './element-select.component.html',
  styleUrls: ['../../../../../../styles/global/_management-styles.scss']
})
export class ElementSelectComponent implements OnChanges {
  selectedValue: string;
  displayOptions: string[] | NameValueDTO[];

  @Input() qaAttr: string;
  @Input() displayLabel = '';
  @Input() disabled = false;
  @Input() defaultValue: string | NameValueDTO;
  @Input() required = false;
  @Output() selectionChanged = new EventEmitter<any>();
  @Input() customCssClasses: Array<string> = [];
  @Input() emitNameValueDTO: boolean;

  private _options: string[] | NameValueDTO[];

  get options(): string[] | NameValueDTO[] {
    return this._options;
  }


  @Input()
  set options(value: string[] | NameValueDTO[]) {
    if (Array.isArray(value) && (value as string[]).every((item: string) => typeof item === 'string')) {
      this._options = value;
      this.displayOptions = value;
    }
    else if (Array.isArray(value) && (value as NameValueDTO[]).every((item: NameValueDTO) => typeof item === 'object' && 'name' in item)) {
      this._options = value;
      this.displayOptions = (value as NameValueDTO[]).map((item: NameValueDTO) => item.name);
    }
    else {
      this._options = [];
      this.displayOptions = [];
    }
  }

  ngOnChanges(_: SimpleChanges): void {
    this.setSelectedValue();
  }

  onValueChange(): void {
    if (this.emitNameValueDTO) {
      const selectedOption: NameValueDTO = (this._options as NameValueDTO[]).find((option: NameValueDTO) => option.name === this.selectedValue);
      this.selectionChanged.emit(selectedOption);
    }
    else {
      this.selectionChanged.emit(this.selectedValue);
    }
  }

  private setSelectedValue(): void {
    if (this.defaultValue && typeof this.defaultValue === 'string') {
      this.selectedValue = this.defaultValue;
    }
    else if (this.defaultValue && typeof this.defaultValue === 'object') {
      this.selectedValue = (this.defaultValue as NameValueDTO).name;
    }
    else {
      this.selectedValue = null;
    }
  }

}
